"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_virtualized_1 = require("@vidazoo/ui-virtualized");
var classnames_1 = require("classnames");
var common_1 = require("../../common");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var select_1 = require("../select");
var trendArrow_1 = require("../trendArrow");
var checkbox_1 = require("../checkbox");
var index_1 = require("../index");
var DataGridHeaderColumn = /** @class */ (function (_super) {
    tslib_1.__extends(DataGridHeaderColumn, _super);
    function DataGridHeaderColumn(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onClick = function (e) {
            var _a = _this.props, sortBy = _a.sortBy, onSort = _a.onSort, enableSort = _a.enableSort, onClick = _a.onClick;
            enableSort && onSort(sortBy);
            onClick && onClick(e);
        };
        _this.openSearch = function () {
            _this.setState({
                isSearchOpen: true
            });
        };
        _this.closeSearch = function () {
            var _a = _this.props, onSearch = _a.onSearch, searchKey = _a.searchKey;
            onSearch(searchKey, "");
            _this.setState({
                isSearchOpen: false
            });
        };
        _this.onSearch = function (e) {
            var _a = _this.props, searchKey = _a.searchKey, onSearch = _a.onSearch;
            onSearch(searchKey, e.target.value);
            utils_1.raf(function () {
                utils_1.triggerUIEvent(window, "resize");
            });
        };
        _this.state = { isSearchOpen: props.searchQuery || false };
        return _this;
    }
    DataGridHeaderColumn.prototype.renderSearchIcon = function () {
        var theme = this.props.theme;
        var isSearchOpen = this.state.isSearchOpen;
        return (React.createElement("div", { className: theme["search-icon"], onClick: utils_1.pauseEvent }, isSearchOpen
            ? React.createElement("div", { onClick: this.closeSearch },
                React.createElement(icon_1.Icon, { size: 1.4, iconName: "icon-cancel-small" }))
            : React.createElement("div", { onClick: this.openSearch },
                React.createElement(icon_1.Icon, { size: 1.4, iconName: "icon-search-small" }))));
    };
    DataGridHeaderColumn.prototype.renderSearchInput = function () {
        var _a = this.props, theme = _a.theme, searchQuery = _a.searchQuery, label = _a.label, searchOptions = _a.searchOptions;
        if (searchOptions && searchOptions.length > 0) {
            return (React.createElement(select_1.FormSelect, { itemLabelKey: "label", itemValueKey: "value", className: theme.select, items: searchOptions, defaultValue: searchQuery, onChange: this.onSearch, placeholder: label, fill: true, searchable: true, autoFocus: true, small: true, style: {
                    padding: 0,
                    border: "none",
                    backgroundColor: "unset"
                }, maxItems: 5 }));
        }
        return (React.createElement("input", { type: "text", size: label.length, autoFocus: true, value: searchQuery, placeholder: label, className: theme.input, onChange: this.onSearch, onClick: utils_1.pauseEvent }));
    };
    DataGridHeaderColumn.prototype.renderSortArrow = function () {
        var _a = this.props, theme = _a.theme, sortDirection = _a.sortDirection;
        var trendDirection = sortDirection === common_1.SortDirection.ASC ? "up" : "down";
        return (React.createElement("div", { className: theme["sort-icon"] },
            React.createElement(trendArrow_1.TrendArrow, { upIconClassName: theme["sort-icon-svg"], downIconClassName: theme["sort-icon-svg"], direction: trendDirection })));
    };
    DataGridHeaderColumn.prototype.render = function () {
        var _a;
        var _b = this.props, setFreezeColumn = _b.setFreezeColumn, freezeColumnIndex = _b.freezeColumnIndex, columnsWidth = _b.columnsWidth, index = _b.index, theme = _b.theme, className = _b.className, purple = _b.purple, deepPurple = _b.deepPurple, orange = _b.orange, gray = _b.gray, blue = _b.blue, children = _b.children, sortable = _b.sortable, searchable = _b.searchable, sortActive = _b.sortActive, label = _b.label, enableSort = _b.enableSort, sortBy = _b.sortBy, sortDirection = _b.sortDirection, onSort = _b.onSort, onSearch = _b.onSearch, searchKey = _b.searchKey, searchQuery = _b.searchQuery, edge = _b.edge, slim = _b.slim, disableEllipsis = _b.disableEllipsis, contextMenuItems = _b.contextMenuItems, others = tslib_1.__rest(_b, ["setFreezeColumn", "freezeColumnIndex", "columnsWidth", "index", "theme", "className", "purple", "deepPurple", "orange", "gray", "blue", "children", "sortable", "searchable", "sortActive", "label", "enableSort", "sortBy", "sortDirection", "onSort", "onSearch", "searchKey", "searchQuery", "edge", "slim", "disableEllipsis", "contextMenuItems"]);
        var isSearchOpen = this.state.isSearchOpen;
        var classes = classnames_1.default(theme.column, className, (_a = {},
            _a[theme.sortable] = sortable,
            _a[theme.searchable] = searchable,
            _a[theme.searched] = isSearchOpen,
            _a[theme.sorted] = sortActive,
            _a[theme.edge] = edge,
            _a[theme.purple] = purple,
            _a[theme.deepPurple] = deepPurple,
            _a[theme.orange] = orange,
            _a[theme.gray] = gray,
            _a[theme.blue] = blue,
            _a[theme.slim] = slim,
            _a));
        var headerColumn = (React.createElement("div", { className: theme.inner, onClick: this.onClick },
            searchable ? this.renderSearchIcon() : null,
            React.createElement("div", { className: theme.label },
                React.createElement("div", { className: theme.text }, label || children),
                isSearchOpen ? this.renderSearchInput() : null),
            sortActive ? this.renderSortArrow() : null,
            setFreezeColumn ? (React.createElement(checkbox_1.Checkbox, { className: theme.freeze, checked: freezeColumnIndex === index, value: index, onChange: setFreezeColumn })) : null));
        return (React.createElement(ui_virtualized_1.ResizableColumn, { width: columnsWidth[index], index: index, className: classes, disableEllipsis: disableEllipsis }, contextMenuItems ? (React.createElement(index_1.ContextMenu, { items: contextMenuItems }, headerColumn)) : headerColumn));
    };
    DataGridHeaderColumn.defaultProps = {
        label: "",
        sortBy: "",
        sortable: false,
        enableSort: true,
        searchable: false,
        disableEllipsis: true,
        searchKey: "",
        searchQuery: "",
        onSort: utils_1.noop,
        onSearch: utils_1.noop,
    };
    return DataGridHeaderColumn;
}(React.Component));
exports.default = DataGridHeaderColumn;
